/* eslint-disable no-case-declarations */
import { actions } from 'react/api/actions/samlConfiguration';
import { fromJS } from 'immutable';

const initialState = fromJS({
  metadata: {
    isInvalid: false,
    isValid: false,
    isLoading: false,
    error: ''
  },
  modals: {
    organization: {
      modalIsOpen: false
    },
    groups: {
      modalIsOpen: false
    },
    localeKey: {
      modalIsOpen: false
    },
    userTag: {
      modalIsOpen: false
    },
    cancelModal: {
      modalIsOpen: false
    }
  }
});

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.openOrganizationFieldsModal:
      return state.mergeIn(['modals', 'organization', 'modalIsOpen'], true);

    case actions.toggleOrganizationFieldsModal:
      const organizationFieldsModalIsOpen = state.getIn([
        'modals',
        'organization',
        'modalIsOpen'
      ]);
      return state.mergeIn(
        ['modals', 'organization', 'modalIsOpen'],
        !organizationFieldsModalIsOpen
      );

    case actions.openLocaleKeyFieldsModal:
      return state.mergeIn(['modals', 'localeKey', 'modalIsOpen'], true);

    case actions.toggleLocaleKeyFieldsModal:
      const localeFieldsModalIsOpen = state.getIn([
        'modals',
        'localeKey',
        'modalIsOpen'
      ]);
      return state.mergeIn(
        ['modals', 'localeKey', 'modalIsOpen'],
        !localeFieldsModalIsOpen
      );

    case actions.openGroupsFieldsModal:
      return state.mergeIn(['modals', 'groups', 'modalIsOpen'], true);

    case actions.toggleGroupsFieldsModal:
      const groupsFieldsModalIsOpen = state.getIn([
        'modals',
        'groups',
        'modalIsOpen'
      ]);
      return state.mergeIn(
        ['modals', 'groups', 'modalIsOpen'],
        !groupsFieldsModalIsOpen
      );

    case actions.openUserTagFieldsModal:
      return state.mergeIn(['modals', 'userTag', 'modalIsOpen'], true);

    case actions.toggleUserTagFieldsModal:
      const userTagsFieldsModalIsOpen = state.getIn([
        'modals',
        'userTag',
        'modalIsOpen'
      ]);
      return state.mergeIn(
        ['modals', 'userTag', 'modalIsOpen'],
        !userTagsFieldsModalIsOpen
      );

    case actions.initializeIdpUrlValidation: {
      return state.merge({
        metadata: {
          isInvalid: false,
          isValid: false,
          isLoading: true
        }
      });
    }

    case actions.stopIdpUrlValidation: {
      return state.merge({
        metadata: {
          isInvalid: false,
          isValid: false,
          isLoading: false
        }
      });
    }

    case actions.confirmIdpUrlValidation: {
      return state.merge({
        metadata: {
          isInvalid: false,
          isValid: true,
          isLoading: false
        }
      });
    }

    case actions.denyIdpUrlValidation: {
      const { error } = action.payload;

      return state.merge({
        metadata: {
          isInvalid: true,
          isValid: false,
          isLoading: false,
          certificate: '',
          error
        }
      });
    }

    case actions.clearCertificate: {
      return state.merge({
        metadata: {
          certificate: ''
        }
      });
    }
    default:
      return state;
  }
};
